module.exports = __webpack_public_path__ + "img/icon_tap_02.bd550b18.svg";